import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import "../layout/header.css";
import QrCode from "../qrCode/qrCode";
import { useFormik } from "formik";
import * as Yup from "yup";
import SignIn from "./signin";
import { AXIOS, api_key } from "../../config";
import "dotenv/config";
import Loader from "../loader/loader";
import { toast } from "react-toastify";
import walet from "../../assets/images/signin/wallet.svg";
import { RiSettingsFill } from "react-icons/ri";
import { MdEmail, MdSms } from "react-icons/md";
import AntTabs from "./antDesignSign/AntTabs";
import { Button } from "react-bootstrap";
import { Axios } from "axios";
import { Link } from "react-router-dom";
import ForgotPasswordModel from './forgotPasswordModel'
import { useDispatch } from "react-redux";
import {updatePath} from '../../store/auth/auth'

import "../register/register.css";

const styles: { [name: string]: React.CSSProperties } = {
  // container: {
  //   marginTop: 50,
  //   display: "flex",
  //   flexDirection: "column",
  //   alignItems: "center",
  //   width:"100%",
  // },
  select: {
    padding: 5,
    width: "100%",
  },
  result: {
    marginTop: 30,
  },
};
function Login() {
  const [referral, setReferral] = useState(false);
  const [showForgotPassword,setShowForgotPassword]= useState(false)
 

  const handleReferral = () => [setReferral(!referral)];
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isLoading, setLoading] = useState<Boolean>(false);
  const [data, setData]: any = useState<Object>();
  
  const [selectedOption, setSelectedOption] = useState<String>();

 
  const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedOption(value);
  };

  const [theme, setTheme] = useState<null | string>("");
  const toggleThem = () => {
    if (theme === "dark-theme") {
      localStorage.setItem("theme", "light-theme");
      setTheme("light-theme");
    } else {
      setTheme("dark-theme");
      localStorage.setItem("theme", "dark-theme");
    }
  };

  const loginSchema = Yup.object().shape({
    // searchType: Yup.string().required("Login Type is required"),
    // user: Yup.string()
    //   .min(0)
    //   .required("Email is Required")
    //   .matches(
    //     /^\w+([\.-]?\w+)@\w+([\.-]?\w+)(\.\w{2,3})+$/,
    //     "Please! Enter a valid email address"
    //   ),
    email: Yup.string()
      .min(0)
      .required("Email is required").email('Please! Enter a valid email address'),
    password: Yup.string()
      .min(8)
      .required("Password is Required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
        "Minimum eight characters, at least one uppercase letter, one lowercase letter and one number"
      ),
    registerType: Yup.string(),

    refId: Yup.string().min(0),
  });
  const formik = useFormik({
    initialValues: {
      registerType: "email",

      email: "",
      password: "",
      refId: "",
      user_id: "",
    },
    validationSchema: loginSchema,

    onSubmit: async (values, action) => {


      let newValues = values;
      setLoading(true);
      if (values.registerType == "email") {
        let checkuser = await AXIOS.post('/checkUser', {
          api_key: api_key,
          registerType: values.registerType,
          data: values.email,
          password: values.password
        })
        
        if (checkuser.data.status == 'fail') {
          if (checkuser.data.showableMessage == 'Email not registered') {
            formik.setErrors({
              ...formik.errors,
              email: 'invalid emial'
            })
          }
          else{
            formik.setErrors({
              ...formik.errors,
              password: 'invalid password'
            })
          }
          toast.error(checkuser.data.showableMessage, { icon: <MdEmail /> });
          setLoading(false);



        }

        else {
          let id = await AXIOS.post(`/getUserId`, {
            api_key: api_key,
            email: values.email,
          });
          newValues = { ...values, user_id: id.data.data[0].user_id };
          await AXIOS.post(`/sendMail`, {
            api_key: api_key,
            user_id: id.data.data[0].user_id,
            reason: "login_verification",
          })
            .then((response) => {
              toast.success("Pin code sent to Email", { icon: <MdEmail /> });

              setData(newValues);
              setLoading(false);
              handleShow();
            })
            .catch((error) => {
              toast.error("Email not sent", { icon: <MdEmail /> });
            });
        }

      } else {

        return 0
        await AXIOS.post(`/sendSMSPin`, {
          api_key: api_key,
          email: values.email,
        })
          .then((response) => {
            toast.success("Pin code sent to Phone Number", { icon: <MdSms /> });
            setData(newValues);
            setLoading(false);
            handleShow();
          })
          .catch((error) => {
            toast.error("Sms not sent", { icon: <MdSms /> });
          });
      }
    },
  });
  console.log('login formik data', formik.values)

  useEffect(() => {
    if (localStorage.getItem("theme") == null) {
      document.body.className = "dark-theme";
      localStorage.setItem("theme", "dark-theme");
      setTheme("dark-theme");
    } else {
      document.body.className = localStorage.getItem("theme")!;
      setTheme(localStorage.getItem("theme"));
    }
  }, [theme]);
  return (
    <div className="register-bg">
      { ! show&& 
       <div className="container-fluid">
       <div className="row justify-content-center">
         <div className="signin_setting">
           {/* <div className="dropdown">
             <button className="bg-transparent border-0 outline-0">
               <RiSettingsFill className="sign-settings-icon" />
             </button>
             <div className="sign-dropdown-content-ldmode">
               <div className="form-check form-switch switch">
                 <input
                   className="form-check-input change light_mode me-3 mt-2"
                   onClick={() => toggleThem()}
                   type="checkbox"
                   role="switch"
                   id="flexSwitchCheckChecked"
                 />
               </div>
             </div>
           </div> */}
           <div className="form-check sign-form-switch switch">
                 <input
                   className="form-check-input change light_mode me-3 mt-2"
                   onClick={() => toggleThem()}
                   type="checkbox"
                   role="switch"
                   id="flexSwitchCheckChecked"
                 />
               </div>
         </div>
         {/* <div className="col-lg-3"></div> */}
         <div className="col-lg-5 d-lg-block d-none left_most p-4">
           <div className="lf_mo_hd text-center">
             <h3>Login with wallet authorization</h3>
             <img src={walet} alt="Wallet" />
             
           </div>
           <div>
             <div className="d-flex justify-content-center mb-2">
               <Button variant="dark w-50"> Enter the Web3 world</Button>
             </div>
             <div className="ms-2">
               <p>
                 No registration required and transactions are authorized by
                 decentralized wallets.
               </p>
               <p>
                 Link your decentralized wallet with one click to authorize
                 transactions of Spot and Perpetual Futures.
               </p>
             </div>
           </div>
         </div>
         <div className="col-lg-5 col-md-12 mt-5 ">
           <div className="row">
             <div className="col-12 d-flex justify-content-center">
               <h2 className="register-headin sign_label">
                 VirtualEX Account Login
               </h2>
             </div>
             <div className="col-12 pb-4 d-flex justify-content-center">
               <span
                 className="welcomeSub"
                 style={{ color: "var(--text-clr)" }}
               >
                 Welcome back!Login with your email or mobile number
               </span>
             </div>
           </div>
           <div className="row ">
             <form
               className="d-flex justify-content-center align-items-center flex-column"
               onSubmit={formik.handleSubmit}
             >
               <div className="col-12 col-md-9">
                
                 <AntTabs formik={formik} />              
               </div>            
               <div className="form-group col-12 col-md-9 mt-2">
                 <label className="mb-2 sign_label" htmlFor="">
                   Password
                 </label>
                 <input
                   type="password"
                   name="password"
                   className="form-control"
                   id="password"
                   placeholder="Password"
                   value={formik.values.password}
                   onChange={formik.handleChange}
                   autoComplete=""
                 />
                 {formik.errors.password && (
                   <div id="password" className="text-danger">
                     {formik.errors.password}
                   </div>
                 )}
               </div>
             

               <div className="col-12 col-md-9 mt-3">
                 {isLoading == false ? (
                 
                     <div className="d-grid gap-2">
                       <button className="btn btn-register mt-2" type="submit" disabled={Boolean(formik.errors.email || formik.values.email=='') || Boolean(formik.values.password=='' || formik.errors.password)}>
                         LOGIN
                       </button>
                     </div>
                     ) : (
                       <div className="d-grid gap-2">
                       <button className="btn btn-register mt-2" type="submit">
                       <Loader />

                       </button>
                     </div>
                 )}
                     <div className=" col-12 col-md-9 d-flex justify-content-between w-100">
                       <a className="text-ForgetPassword text-decoration-none" 
                   onClick={() => setShowForgotPassword(true)}
                   
                         >Forget Password ?</a>
                       <a
                         className="text-ForgetPassword text-decoration-none"
                         onClick={() => {
                           navigate("/register");
                           dispatch(updatePath('register'))
                         }}
                       >
                         Register For Free
                       </a>
                     </div>
                   
                 
               </div>

             </form>
           </div>
           <div className="row d-flex justify-content-center">
             <div className="col-md-9 col-12 gap-0">
           
               <div className="d-grid gap-2">
                       <button className="btn btn-register mt-2" type="submit">
                       Login with Google
                       </button>
                     </div>
             </div>
           </div>
         </div>
         <div className="col-md-12 col-lg-2 p-1 mt-5 pe-lg-3 qr_sec">
           <div className="login_qr rounded">
             <QrCode sizeOfQR={130} value={"https://www.youtube.com/"} />
           </div>
           <span className="tex-loginWith">Log in with QR code</span>
           <p
             className="pt-2 text-center"
             style={{ color: "var(--text-clr)" }}
           >
             Scan this code with the Virtual Exchange mobile app to log in
             instantly.
           </p>
         </div>
       </div>
     </div>
      }
     
      {show && <SignIn show={show} handleClose={handleClose} data={data}  email={formik.values.email}/>}
      <ForgotPasswordModel showForgotPassword={showForgotPassword} setShowForgotPassword={setShowForgotPassword} />

    </div>
  );
}

export default Login;
